// Shiprocket hosted checkout (test). Backend flag decides if it is used.
import { getUTM } from "./utm";
import { getGaIds, gaFunnel } from "./ga";

const API = process.env.REACT_APP_BACKEND_URL;
const SDK = "https://checkout-ui.shiprocket.com/assets/js/channels/custom.js";
let configPromise = null;
let sdkPromise = null;

export const getSrCheckoutConfig = () => {
  if (!configPromise) {
    configPromise = fetch(`${API}/api/sr/checkout/config`).then((r) => r.json()).catch(() => ({ enabled: false }));
  }
  return configPromise;
};

export const loadSrSdk = (sellerDomain) => {
  if (sdkPromise) return sdkPromise;
  if (!document.getElementById("sellerDomain")) {
    const inp = document.createElement("input");
    inp.type = "hidden"; inp.id = "sellerDomain"; inp.value = sellerDomain;
    document.body.appendChild(inp);
  }
  sdkPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = SDK; s.async = true;
    s.onload = () => resolve(true);
    s.onerror = () => { sdkPromise = null; reject(new Error("sdk")); };
    document.body.appendChild(s);
  });
  return sdkPromise;
};

const readCookie = (n) => document.cookie.split("; ").find((c) => c.startsWith(n + "="))?.split("=")[1] || null;

export const openSrCheckout = async (evt, onClose) => {
  const cfg = await getSrCheckoutConfig();
  if (!cfg.enabled) throw new Error("disabled");
  await loadSrSdk(cfg.sellerDomain);
  const ctrl = new AbortController();
  const timer = setTimeout(() => ctrl.abort(), 6000);
  let r, d;
  try {
    r = await fetch(`${API}/api/sr/checkout/token`, {
      method: "POST", headers: { "Content-Type": "application/json" }, signal: ctrl.signal,
      body: JSON.stringify({ utm: getUTM(), fbp: readCookie("_fbp"), fbc: readCookie("_fbc"), ga: getGaIds() }),
    });
    d = await r.json();
  } finally {
    clearTimeout(timer);
  }
  if (!r.ok || !d.token) throw new Error(d?.detail || "token");
  if (!window.HeadlessCheckout?.addToCart) throw new Error("sdk");
  window.HeadlessCheckout.addToCart(evt, d.token, { fallbackUrl: `${window.location.origin}/order` }, (e) => {
    if (e?.event === "sr-headless-close") onClose?.(e);
  });
  // Popup actually opened → GA4 begin_checkout (in-popup stages come server-side via Shiprocket webhooks)
  gaFunnel("begin_checkout", d.price || 499, { checkout_source: "shiprocket" });
  return d;
};
